import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { InMemoryScrollingOptions, provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, HttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideStore, StoreModule } from '@ngrx/store';
import { provideStoreDevtools, StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { appReducers } from './app.reducer';
import { environment } from '../environments/environment';
import { LAZYLOAD_IMAGE_HOOKS, ScrollHooks } from 'ng-lazyload-image';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { provideNgxMask } from 'ngx-mask';

// Interceptores basados en clases
import { refreshTokenInterceptor } from './interceptors/refresh-token.interceptor';
import { errorsInterceptor } from './interceptors/errors.interceptor';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GoogleMapsModule } from '@angular/google-maps';
import { provideLottieOptions } from 'ngx-lottie';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';

import localeEsMX from '@angular/common/locales/es-MX';
import { registerLocaleData } from '@angular/common';
import { timeoutInterceptor } from './interceptors/timeout.interceptor';
registerLocaleData(localeEsMX, 'es-MX');

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './../assets/i18n/', `.json?v=${environment.version}`);
}

const scrollConfig: InMemoryScrollingOptions = {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(
            routes,
            withInMemoryScrolling(scrollConfig),
            withEnabledBlockingInitialNavigation()
        ),
        provideHttpClient(
            withInterceptors([
                refreshTokenInterceptor,
                errorsInterceptor,
                timeoutInterceptor
            ])
        ),
        provideAnimations(),
        provideStore(appReducers),
        provideStoreDevtools({
            maxAge: 25,
            logOnly: environment.production
        }),
        provideLottieOptions({
            player: () => import('lottie-web'),
        }),
        importProvidersFrom(
            StoreModule.forRoot(appReducers),
            StoreDevtoolsModule.instrument({
                maxAge: 25,
                logOnly: environment.production
            }),
            StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
            TranslateModule.forRoot({
                defaultLanguage: 'es',
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient]
                }
            }),
            RecaptchaV3Module,
            GoogleMapsModule,
            MatSnackBarModule,
            MatDialogModule
        ),
        { provide: LAZYLOAD_IMAGE_HOOKS, useClass: ScrollHooks },
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },
        provideNgxMask(),
        { provide: LOCALE_ID, useValue: 'es-MX' }
    ]
};
